import SearchResultsPresenter from '../../components/search/SearchResults';
import { connect } from 'react-redux';
import {withRouter} from "react-router-dom";
import {fetchObjectList} from "../../actions/objectList";

const getEntryTypeNameList = (objectList) => {
    let entryTypeNameList = [];

    if (objectList.getState().isDone()) {
        entryTypeNameList = objectList.getData().map((item, key) => { return {type: item.type, name: item.name, color: item.properties.typeColor};});
    }

    return entryTypeNameList;
};

const mapStateToProps = (state, ownProps) => {
    return {
        entryTypeNameList: getEntryTypeNameList(state.objectList),
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onMount() {
            dispatch(fetchObjectList());
        },
    }
};

const SearchResults = connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchResultsPresenter);

export default withRouter(SearchResults);